import(/* webpackMode: "eager" */ "/vercel/path0/src/app/bgt/validator/page.tsx");
